module.exports = __webpack_public_path__ + "img/seo_gfish_item02.4a5d47a.webp";